//Services or Api
import requestService from './../api';
import { ACTION_TYPES, MUTATION_TYPES } from './types';

export const actions = {
  async [ACTION_TYPES.RESET](context) {
    context.commit(MUTATION_TYPES.RESET);
  },
  //Basic and Initial Collection of Advanced
  async [ACTION_TYPES.GET_FILTERS](context, { isAdvanced }) {
    //Valid if filters is already loaded
    context.dispatch('$_app/setLoading', true, { root: true });
    let loadFilters = false;
    if (context.state.filters.academicYears.length == 0 && !isAdvanced) {
      loadFilters = true;
    } else if (context.state.filters.services.length == 0 && isAdvanced) {
      loadFilters = true;
    }

    if (loadFilters) {
      if (isAdvanced) {
        const [
          services,
          disciplines,
          statuses,
          centers,
        ] = await requestService.getFilters(isAdvanced);

        const data = {
          services: services == undefined ? [] : services,
          disciplines: disciplines == undefined ? [] : disciplines,
          statuses: statuses == undefined ? [] : statuses,
          centers: centers == undefined ? [] : centers,
        };
        context.commit(MUTATION_TYPES.SET_FILTERS, data);
      } else {
        const [academicYear] = await requestService.getFilters(isAdvanced);

        const data = {
          academicYears: academicYear,
        };
        context.commit(MUTATION_TYPES.SET_FILTERS, data);
      }
    }
    context.dispatch('$_app/setLoading', false, { root: true });
  },
  async [ACTION_TYPES.GET_REQUESTS](context, filters) {
    //Business Logic and later call mutation is required
    context.commit(MUTATION_TYPES.SET_CURRENT_FILTERS, filters);
    //Search filters
    let params = {
      AcademicYearId: filters.selectedYear ? filters.selectedYear.id : null,
      SearchText: filters.searchText,
      StudentSieId: filters.studentSie,
      //WHY?
      EvaluationTypeId:
        filters.selectedService != null ? filters.selectedService.id : null,
      DisciplineId:
        filters.selectedDiscipline != null
          ? filters.selectedDiscipline.id
          : null,
      ReferralStatusId:
        filters.selectedStatus != null ? filters.selectedStatus.id : null,
      //WHY?
      CenterId:
        filters.selectedCenter != null ? filters.selectedCenter.id : null,

      RegionId:
        filters.selectedRegion != null ? filters.selectedRegion.id : null,
      MunicipalityId:
        filters.selectedMunicipality != null
          ? filters.selectedMunicipality.id
          : null,
      LocationSchoolId:
        filters.selectedSchool != null ? filters.selectedSchool.id : null,
      OrderBy: parseInt(filters.orderBy), //Backend is int front end use bool and string :'(
      StartRowIndex: filters.startRowIndex,
      MaxRowIndex: filters.maxRowIndex,
      //WHY?
      SelectedServiceId:
        filters.SelectedService != null ? filters.SelectedService.id : null,
      //WHY?
      selectedCenterId:
        filters.SelectedCenter != null ? filters.SelectedCenter.id : null,
    };

    const { data } = await requestService.getRequests(params);
    if (data) {
      context.commit(MUTATION_TYPES.SET_REQUESTS, data);
    }
  },
  async [ACTION_TYPES.GET_CENTERS](context, params) {
    const response = await requestService.getCenters(params);

    if (response) {
      context.commit(MUTATION_TYPES.SET_CENTERS, response);
    }
  },
  async [ACTION_TYPES.GET_REGIONS](context, params) {
    const response = await requestService.getRegions(params);

    if (response) {
      context.commit(MUTATION_TYPES.SET_REGIONS, response);
    }
  },
  async [ACTION_TYPES.GET_MUNICIPALITIES](context, params) {
    const response = await requestService.getMunicipalities(params);

    if (response) {
      context.commit(MUTATION_TYPES.SET_MUNICIPALITIES, response);
    }
  },
  async [ACTION_TYPES.GET_SCHOOLS](context, params) {
    const response = await requestService.getSchools(params);

    if (response) {
      context.commit(MUTATION_TYPES.SET_SCHOOLS, response);
    }
  },
  setProvisionalRemedyRequest(context, ProvisionalRemedyRequest) {
    context.commit('setProvisionalRemedyRequest', ProvisionalRemedyRequest);
  },
  setFiltersFromProvisionalRemedyRequest(
    context,
    FiltersFromProvisionalRemedyRequest
  ) {
    context.commit(
      'setFiltersFromProvisionalRemedyRequest',
      FiltersFromProvisionalRemedyRequest
    );
  },
};
